const BOOKINGS_APP_DEF_ID = '13d21c63-b5ec-5912-8397-c3a5ddb27a97';
const BOOKINGS_FORM_SECTION_ID = 'Booking Form';
export const isBookingsInstalled = async _ref => {
  let {
    wixCodeApi
  } = _ref;
  try {
    return wixCodeApi.site.isAppSectionInstalled({
      appDefinitionId: BOOKINGS_APP_DEF_ID,
      sectionId: BOOKINGS_FORM_SECTION_ID
    });
  } catch (e) {
    console.error('Failed to check if bookings is installed', e);
    return false;
  }
};
//# sourceMappingURL=is-booking-installed.js.map